import { EnvironmentCheckItemToRender } from '../CheckResults';
import { useContext } from 'react';
import TranslationsContext from 'translations/TranslationsContext';
import React from 'react';


interface IDetailsColumnProps {
	item: EnvironmentCheckItemToRender;
}

const capitalizeFirstLetter = (text: string): string  => text.charAt(0).toUpperCase() + text.slice(1);

const DetailsColumn = ({ item }: IDetailsColumnProps) => {
	const { t } = useContext(TranslationsContext)!;

	let content: string = '';
	let title: string | undefined = undefined;

	if (item.errorCode) {
		const translationKeyTitle = `Errors.${item.errorCode}.errorTitle`;
		title = t(translationKeyTitle);

		if (item.problem) {
			const translationKeyDescription = `Errors.${item.errorCode}.errorDescription`;
			content = t(translationKeyDescription, item.problem);
		}
	}
	else if (item.titleKey) {
		const keyWithCapitalizedFirstLetter = capitalizeFirstLetter(item.titleKey);
		const translationKeyTitle = `EnvironmentCheckResponse.${keyWithCapitalizedFirstLetter}.Title`;
		title = t(translationKeyTitle);

		const translationKeyDescription = `EnvironmentCheckResponse.${keyWithCapitalizedFirstLetter}.Success`;
		const text = t(translationKeyDescription, item);
		content = text === translationKeyDescription ? '' : text;
	}

	return <span title={title}>{content}</span>;
};

export default DetailsColumn;
